import { render, staticRenderFns } from "./LegalStatement.vue?vue&type=template&id=33357397&scoped=true&"
import script from "./LegalStatement.vue?vue&type=script&lang=js&"
export * from "./LegalStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33357397",
  null
  
)

export default component.exports